import { render, staticRenderFns } from "./HowWeWork.vue?vue&type=template&id=375428cf&scoped=true"
import script from "./HowWeWork.vue?vue&type=script&lang=ts"
export * from "./HowWeWork.vue?vue&type=script&lang=ts"
import style0 from "./HowWeWork.vue?vue&type=style&index=0&id=375428cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375428cf",
  null
  
)

export default component.exports